<template>
  <td :colspan="row" class="bg-light">
    <div class="bg-none"></div>
  </td>
</template>
<script>
export default {
  props: {
    row: { default: 5 },
  },
};
</script>